// extracted by mini-css-extract-plugin
export default {"wrapper":"RDW2021_wrapper__lQtfJ"};